import React, { useEffect, useState, useContext } from "react";
import { connect } from "react-redux";
import CustomModal from "./ButtonModal";
import CloneICON from "../../../assets/images/clone.svg";
import CustomElement from "../../../assets/images/custom-elements.svg";
import * as actionTypes from "../../../store/Actions/actions";
import * as UTILS from "../../../utils/Utils";
import cloneDeep from "lodash.clonedeep";
import { CustomElementsContext } from "../../../context/CustomElementsContext";

const BUTTON = (props) => {
  const [state, setState] = useState({
    hover: false,
    rotate: false,
    id: null,
    linkOptionOpen: false,
    enableContentModal: false,
    normalTextColor: props.normalTextColor,
    normalBtnBg: props.normalBtnBg,
    normalBtnBorder: props.normalBtnBorder,
    hoverBtnTextColor: props.hoverBtnTextColor,
    hoverBtnBgColor: props.hoverBtnBgColor,
    hoverBorder: props.hoverBorder,
    colorPicker: false,
    results: "",
    isCustomButton: false,
    buttonSettings: false
  });
  const { customButtons, setCustomButtons } = useContext(CustomElementsContext);
  useEffect(() => {

    if (props.fullWidth == "100%" & (props.marginRight !== "0" || props.marginLeft !== "0")) {
        const layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.style.marginRight = "0";
          item.style.marginLeft = "0";
        },
        (colItem) => {
          colItem.style.marginRight = "0";
          colItem.style.marginLeft = "0";
        },
        (colItemNested) => {
          colItemNested.style.marginRight = "0";
          colItemNested.style.marginLeft = "0";
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }

    var customButton = customButtons.filter((button) => {
      return (
        JSON.stringify(button.custom_element_name) ===
        JSON.stringify(props.element.customElementName)
      );
    });

    setState({
      ...state,
      isCustomButton: customButton.length === 0 ? false : true,
    });
  }, [props, customButtons, state.isCustomButton,]);

  const toggleHover = (e) => {
    setState({ ...state, hover: e });
  };
  const enableModal = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setState({ ...state, enableContentModal: true }, () => {
      let contentModalDiv = document.querySelector("body .contentModal");
      !contentModalDiv && document.body.classList.contains("my-class-name")
        ? null
        : (document.body.className += " contentModalEnabled");
    });
  };

  const btnTXT =
    typeof props.normalTextColor == "string"
      ? props.normalTextColor
      : `rgba(
          ${props.normalTextColor.r},
          ${props.normalTextColor.g},
          ${props.normalTextColor.b},
          ${props.normalTextColor.a}
          )`;
  const btnBG =
    typeof props.normalBtnBg == "string"
      ? props.normalBtnBg
      : `rgba(
${props.normalBtnBg.r},
${props.normalBtnBg.g},
${props.normalBtnBg.b},
${props.normalBtnBg.a}
)`;
  const btnBorder =
    typeof props.normalBtnBorder == "string"
      ? props.normalBtnBorder
      : `rgba(
${props.normalBtnBorder.r},
${props.normalBtnBorder.g},
${props.normalBtnBorder.b},
${props.normalBtnBorder.a}
)`;

  const btnTXTHover =
    typeof props.hoverBtnTextColor == "string"
      ? props.hoverBtnTextColor
      : `rgba(
${props.hoverBtnTextColor.r},
${props.hoverBtnTextColor.g},
${props.hoverBtnTextColor.b},
${props.hoverBtnTextColor.a}
)`;
  const btnBGHover =
    typeof props.hoverBtnBgColor == "string"
      ? props.hoverBtnBgColor
      : `rgba(
${props.hoverBtnBgColor.r},
${props.hoverBtnBgColor.g},
${props.hoverBtnBgColor.b},
${props.hoverBtnBgColor.a}
)`;
  const btnBorderHover =
    typeof props.hoverBorder == "string"
      ? props.hoverBorder
      : `rgba(
${props.hoverBorder.r},
${props.hoverBorder.g},
${props.hoverBorder.b},
${props.hoverBorder.a}
)`;

  let buttonText = state.hover ? btnTXTHover : btnTXT;
  let buttonBg = state.hover ? btnBGHover : btnBG;
  let buttonBorder = state.hover ? btnBorderHover : btnBorder;

  return (
    <>
  
    <div
      style={
        props.mobileView
          ? {
            position:'relative',
              justifyContent: `${
                props.mobileAlignment == "left"
                  ? "flex-start"
                  : props.mobileAlignment == "right"
                  ? "flex-end"
                  : "center"
              }`,
            }
          : {
            position: 'relative',
              justifyContent: `${
                props.floatVal == "left"
                  ? "flex-start"
                  : props.floatVal == "right"
                  ? "flex-end"
                  : "center"
              }`,
            }
      }
      className={"button-wrapper"}
    >
   

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop:
            props.paddingTop +
            (props.btnPaddingUnit ? props.btnPaddingUnit : "px"),
          paddingLeft:
            props.paddingLeft +
            (props.btnPaddingUnit ? props.btnPaddingUnit : "px"),
          paddingBottom:
            
            props.paddingBottom +
            (props.btnPaddingUnit ? props.btnPaddingUnit : "px"),
          paddingRight:
            props.paddingRight +
            (props.btnPaddingUnit ? props.btnPaddingUnit : "px"),
          width: props.fullWidth,
          maxWidth: props.mobileView? '375px' : '100%',
          marginTop:
            props.marginTop +
            (props.btnMarginUnit ? props.btnMarginUnit : "px"),
      
          marginBottom:
            props.marginBottom +
            (props.btnMarginUnit ? props.btnMarginUnit : "px"),

          marginLeft:
        props.marginLeft +
            (props.btnMarginUnit ? props.btnMarginUnit : "px"),
    
          marginRight:
props.marginRight +
            (props.btnMarginUnit ? props.btnMarginUnit : "px"),
          width: props.fullWidth,
          fontWeight: props.fontWeight || "normal",
          borderStyle: "solid",
          borderRadius: props.borderRadius + "px",
          borderWidth: props.borderWidth + "px",
          backgroundColor: buttonBg,
          borderColor: buttonBorder,
          whiteSpace: "normal",
        }}
        onMouseEnter={() => {
          toggleHover(true);
        }}
        onMouseLeave={() => {
          toggleHover(false);
        }}
        id={props.ID}
        className={"btn btn-flimp "}

      >
        <p
          style={{
            fontFamily: props.fontName ? props.fontName : props.selectedFont,
            fontSize: props.fontSize + "px",
            color: buttonText,
          }}
        >
          {props.content}
        </p>
      </div>
      {state.buttonSettings ? (
        <CustomModal
          element={props.element}
          mobileAlignment={
            props.mobileAlignment ? props.mobileAlignment : "none"
          }
          pagesList={props.pagesList}
          closeModal={() => {
            setState({ ...state, colorPicker: false, buttonSettings: false });
          }}
          Link={props.Link}
          fullWidth={props.fullWidth}
          LinkName={props.LinkName}
          LinkType={props.LinkType}
          LinkOpen={props.LinkOpen}
          UseSocial={props.UseSocial}
          closePopup={() => {
            setState({ ...state, colorPicker: false, buttonSettings: false });
          }}
          heading="Button Settings"
          buttonURL={props.buttonURL}
          ID={props.ID}
          label={props.label}
          googleFonts={UTILS.googleFonts}
          style={props.style}
          fontName={props.fontName}
          content={props.content}
          fontSize={props.fontSize}
          borderRadius={props.borderRadius}
          border={props.borderWidthVal}
          fontWeight={props.fontWeight || "normal"}
          paddingTop={props.paddingTop}
          paddingRight={props.paddingRight}
          paddingBottom={props.paddingBottom}
          paddingLeft={props.paddingLeft}
          btnPaddingUnit={props.btnPaddingUnit}
          btnMarginUnit={props.btnMarginUnit}
          marginTop={props.marginTop}
          marginRight={props.marginRight}
          marginBottom={props.marginBottom}
          marginLeft={props.marginLeft}
          floatVal={props.floatVal}
          normalTextColor={props.normalTextColor}
          normalBtnBg={props.normalBtnBg}
          normalBtnBorder={props.normalBtnBorder}
          hoverBtnTextColor={props.hoverBtnTextColor}
          hoverBtnBgColor={props.hoverBtnBgColor}
          hoverBorder={props.hoverBorder}
        />
      ) : null}
      </div>
      <div className="actionControl">
        {state.isCustomButton === true ? (
          <span className="custom-element"></span>
        ) : (
          ""
        )}

        <span
          className="button text-setting"
          onClick={() => {
            setState({ ...state, colorPicker: true, buttonSettings: true });
          }}
        >
          Button Settings
        </span>
        <button className="clone-item" onClick={() => { props.cloneElement(props.element.id) }}>
          <img src={CloneICON} />
        </button>
        <span
          className="delete-item"
          onClick={() => {
            props.deleteElement(props.ID);
          }}
        >
          <i className="far fa-trash-alt" />
        </span>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BUTTON);
